import { useMutation } from 'react-query';
import { AxiosResponse } from 'axios';

// configs
import { API } from 'configs/api';
// types
import { ICreateInteractiveCtaClick } from './types';

const createInteractiveCtaClickMutation = async ({
  data,
  shortUrl,
}: {
  data: ICreateInteractiveCtaClick;
  shortUrl: string;
}) => {
  if (!shortUrl) {
    throw new Error('Invalid url');
  }
  const response: AxiosResponse = await API.post(
    `/playback/${shortUrl}/interactive-cta-clicks`,
    data
  );

  return response.data;
};

export const useCreateInteractiveCtaClickMutation = () => {
  return useMutation(createInteractiveCtaClickMutation);
};
